
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-starting.json") })
        }
      }, "path---tags-starting");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---tags-starting!./.cache/json/tags-starting.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---tags-starting!./.cache/json/tags-starting.json
// module chunks = 45